import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { url } from "src/app/config/config";
import { catchError, map } from "rxjs/operators";
import { Observable, throwError } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class GenericService {
  public myurl = url + "generic/";
  public informesUrl = url + "informes/";

  private myurlOld = "https://campanaragricola.com/productos/ws/generic/";

  constructor(private http: HttpClient) {}

  getList(database) {
    console.log(this.myurl + "list.php?database=" + database);
    return this.http.get(this.myurl + "list.php?database=" + database).pipe(
      map((res) => {
        console.log(res)
        return res;
      })
    );
  }

  getListNoDate(database){
    return this.http
      .get(this.myurl + 'listNoDate.php?database=' + database)
      .pipe(
        map((res) => {
          return res
        })
      )
  }

  getListSimple(database) {
    return this.http
      .get(this.myurl + "listSimple.php?database=" + database)
      .pipe(
        map((res) => {
          return res;
        })
      );
  }

  getListSimpleParameter(database, parameter, parameterValue) {
    return this.http
      .get(
        this.myurl +
          "listSimpleParameter.php?database=" +
          database +
          "&parameter=" +
          parameter +
          "&parameter_value=" +
          parameterValue
      )
      .pipe(
        map((res) => {
          return res;
        })
      );
  }
  getId(id, database) {
    let headers = new HttpHeaders();
    let body = JSON.stringify([{ id: id }]);
    headers.append("Content-Type", "application/json");
    return this.http
      .post(this.myurl + "getId.php?database=" + database, body, {
        headers: headers,
      })
      .pipe(
        map((res) => {
          return res;
        })
      );
  }

  create(product: any, database) {
    let headers = new HttpHeaders();
    let body = JSON.stringify(product);
    headers.append("Content-Type", "application/json");

    return this.http
      .post(this.myurl + "create.php?database=" + database, body, {
        headers: headers,
      })
      .pipe(
        map((resp) => {
          return resp;
        })
      );
  }
  /*  duplicateCuaderno(id: any) {
    let headers = new HttpHeaders();
    let body = JSON.stringify({id:id});
    headers.append('Content-Type', 'application/json');

    return this.http.post(this.myurl + "duplicate.php", body, { headers: headers }).pipe(map(resp => {
      return resp;
    }))
  } */
  update(cuaderno: any, database) {
    let headers = new HttpHeaders();
    let body = JSON.stringify(cuaderno);
    headers.append("Content-Type", "application/json");

    return this.http
      .put(this.myurl + "update.php?database=" + database, body, {
        headers: headers,
      })
      .pipe(
        map((resp) => {
          return resp;
        })
      );
  }
  delete(id, database) {
    let headers = new HttpHeaders();
    headers.append("Content-Type", "application/json");

    const params = new HttpParams()
      .set("id", id.toString())
      .set("database", database);

    return this.http.delete(this.myurl + "delete.php", { params }).pipe(
      map((data) => {
        return data;
      })
    );
  }

  getIdOld(id, database) {
    let headers = new HttpHeaders();
    headers.append("Content-Type", "application/json");
    const params = new HttpParams()
      .set("id", id.toString())
      .set("database", database)

    console.log('getIdOld', id, database);

    // let body = JSON.stringify([{ id: id }]);
    // headers.append("Content-Type", "application/json");
    return this.http
      .get(this.myurl + "getIdOld.php", {params})
      .pipe(
        map((data) => {
          return data;
        })
      );
  }

  informe(id, database) {
    let headers = new HttpHeaders();
    let body = JSON.stringify([{ id: id }]);

    headers.append("Content-Type", "application/json");
    return this.http
      .post(this.informesUrl + "genericId.php?database=" + database, body, {
        headers: headers,
      })
      .pipe(
        map((res) => {
          return res;
        })
      );
  }
  /**
   *  Enviar el campo de base de datos
   *  el valor de ese campo
   * y la base de datos que necesitamos acceder
   *
   * @param {*} field
   * @param {*} value
   * @param {*} database
   * @returns
   * @memberof GenericService
   */
  getNameField(field, value, database) {
    let headers = new HttpHeaders();
    let body = JSON.stringify([{ field: field, value: value }]);

    headers.append("Content-Type", "application/json");
    return this.http
      .post(this.myurl + "getNameField.php?database=" + database, body, {
        headers: headers,
      })
      .pipe(
        map((res) => {
          return res;
        })
      );
  }

  deleteImageFrutoHueso(id, database) {
    return this.getId(id, database)
      .toPromise()
      .then((resp: any) => {
        console.log("resp", resp);

        let nombre = resp[0].nombre;

        return this.http
          .get(url + "fileupload/fileDelteImageFrutos.php?nombre=" + nombre)
          .toPromise();
      });
  }

  clone(myid: string, database) {
    console.log('genericService', myid, database)
    let headers = new HttpHeaders();
    let id = myid;
    let body = JSON.stringify(id);
    headers.append("Content-Type", "application/json");

    return this.http
      .post(this.myurl + "clone.php?database=" + database, body, {
        headers: headers,
      })
      .pipe(
        map((resp) => {
          return resp;
        })
      );
  }

  cloneOld(myid: string, database: string) {
    // Construimos la query en la URL
    const queryString = `cloneOld.php?database=${encodeURIComponent(database)}&id=${encodeURIComponent(myid)}`;
    return this.http.get(this.myurl + queryString, {});
  }
  

  getVariedadesPaises(database: string): Observable<any> {
    return this.http.get(this.myurl + 'brio_variedades_porcentaje.php?database=' + database).pipe(
      map((res) => {
        return res;
      })
    );
  }


  // PHP 5.2.17
  private buildQueryString(obj: any): string {
    let query = "";
    for (const key in obj) {
      if (obj.hasOwnProperty(key) && obj[key] !== undefined && obj[key] !== null) {
        query += `&${key}=${encodeURIComponent(obj[key])}`;
      }
    }
    return query;
  }

  createOld(product: any, database: string) {

    let queryString = `create.php?database=${encodeURIComponent(database)}`;
    queryString += this.buildQueryString(product);


    return this.http.get(
      this.myurl + queryString,
      {}

    );
  }

  updateOld(product: any, database: string) {

    let queryString = `create.php?database=${encodeURIComponent(database)}`;
    queryString += this.buildQueryString(product);

    return this.http.put(
      this.myurlOld + queryString,
      {}
    );
  }

}
